// extracted by mini-css-extract-plugin
export default {"error":"errorMessage_error__WjTQb","error__icon":"errorMessage_error__icon__MDwMe"};